export const CHECK_COPY: Record<string, string> = {
  rows_resolved:
    'Review status is green for all companies (fully reviewed, no review needed, and no deferred price still outstanding)',
  carry_forward: 'Marks match the previous day\'s saved CSV except where this day called for a new price',
  mark_present: 'A valid mark is present for every company',
  market_data_complete: 'Secondary and public comp data has finished loading',
};

// Falls through to the raw code, so an unmapped provider reads as itself.
export const MARKET_DATA_PROVIDER_LABELS: Record<string, string> = {
  CAPIQ: 'Cap IQ',
  CAPLIGHT: 'Caplight',
  FORGE: 'Forge',
  NOTICE: 'Notice',
  TWELVE_DATA: 'Twelve Data',
  ZANBATO: 'Zanbato',
};

// Re-check this long after the latest pending run is expected to finish, so the
// run has landed by the time we ask again.
export const MARKET_DATA_RECHECK_BUFFER_MS = 15_000;
// When there is no estimate, or it has already passed.
export const MARKET_DATA_RECHECK_FALLBACK_MS = 60_000;
export const MARKET_DATA_RECHECK_MIN_MS = 5_000;
